var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-subheader", { staticClass: "title-setting" }, [
        _vm._v("Mi Empresa"),
      ]),
      _c(
        "v-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.save.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _c("v-text-field", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'",
                    },
                  ],
                  attrs: {
                    filled: "",
                    "data-vv-as": "Razon Social",
                    label: "Razon Social",
                    name: "business_name",
                  },
                  model: {
                    value: _vm.mainItem.business_name,
                    callback: function ($$v) {
                      _vm.$set(_vm.mainItem, "business_name", $$v)
                    },
                    expression: "mainItem.business_name",
                  },
                }),
                _c("span", { staticClass: "red--text" }, [
                  _vm._v(_vm._s(_vm.errors.first("business_name"))),
                ]),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-6" },
              [
                _vm.mainItem.logo_url != null &&
                _vm.mainItem.logo_url.length > 0
                  ? _c("img", {
                      staticStyle: {
                        "object-fit": "cover",
                        "max-width": "200px",
                        "max-height": "100px",
                      },
                      attrs: { src: _vm.mainItem.logo_url },
                    })
                  : _vm._e(),
                _vm.mainItem.logo_url == null || _vm.mainItem.logo_url == ""
                  ? _c("v-avatar", { attrs: { size: "130px" } }, [
                      _c("img", {
                        staticStyle: { "object-fit": "cover" },
                        attrs: { src: require("@/assets/images/no-photo.png") },
                      }),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("p", { staticClass: "caption" }, [
                  _vm._v("Tamaño recomendado 200x100px"),
                ]),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "primary", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.uploadImage()
                      },
                    },
                  },
                  [_vm._v(" Adjuntar logo")]
                ),
                _c("v-file-input", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  ref: "image_ref",
                  attrs: { label: "File input", name: "image_upload" },
                  on: {
                    change: function ($event) {
                      return _vm.setImage()
                    },
                  },
                  model: {
                    value: _vm.mainItem.image_upload,
                    callback: function ($$v) {
                      _vm.$set(_vm.mainItem, "image_upload", $$v)
                    },
                    expression: "mainItem.image_upload",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12 mt-4 text-right" },
              [
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "green darken-1",
                      text: "",
                      loading: _vm.loading,
                      type: "submit",
                    },
                  },
                  [_vm._v(" Guardar ")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }